export default __webpack_public_path__ + "static/media/4699.08812afc.png";